import qs from 'qs';

export const SET_ROUTE_PARAMS = 'app/SET_ROUTE_PARAMS';
export const setRouteParams = routeParams => ({ type: SET_ROUTE_PARAMS, routeParams });

export const SET_ROUTE_QUERY = `app/SET_ROUTE_QUERY`;
export const setRouteQuery = routeQuery => ({ type: SET_ROUTE_QUERY, routeQuery });

const NUMERIC_VALUE = /^\d+$/;

const parseObj = obj =>
  Object.entries(obj).reduce((params, [param, value]) => {
    if (NUMERIC_VALUE.test(value)) {
      params[param] = Number(value);
    } else {
      params[param] = value;
    }
    return params;
  }, {});

const initialState = {
  params: {},
  query: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_ROUTE_PARAMS:
      return {
        ...state,
        params: parseObj(action.routeParams),
      };
    case SET_ROUTE_QUERY:
      return {
        ...state,
        query: parseObj(qs.parse(action.routeQuery, { ignoreQueryPrefix: true })),
      };
    default:
      return state;
  }
};
